(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsClickSignErrorsController', reports);

  reports.$inject = ['$scope', '$http', 'NotificationService'];

  function reports ($scope, $http, NotificationService) {
    	var vm = this;
    	$scope.vm = vm;

    vm.loading = false;

    vm.exportAs = 'csv';

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    vm.download = function () {
      vm.loading = true;
      $http.get(apiUrl + '/reports/click_sign_errors', {
        params: {
          filters: vm.filters,
          exportAs: vm.exportAs
        }
      })
        .then(function ({ data, status, headers, config }) {
          vm.loading = false;
          if (data.success === false) {
            NotificationService.errorHandler(data, 'Erro ao gerar relatório.');
            return;
          }

          if (data.indexOf('no_records') >= 0) {
            NotificationService.errorHandler(data, 'Sem dados neste período.');
            return;
          }

          if (data) {
            var filename = headers('Mktzap-Filename') || 'click_sign_errors.csv';

            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' }); // Make sure it's not visible
            angular.element(document.body).append(anchor); // Attach to document

            var blob = new Blob([data], { type: headers('Content-type') });
            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove(); // Clean it up afterwards
            URL.revokeObjectURL(csvUrl); // Clean memory blob
          } else {
            NotificationService.errorHandler(data, 'Sem dados neste período.');
          }
        }, function ({ data, status, headers, config }) {
          NotificationService.errorHandler(data, 'Erro ao gerar relatório.');
        })
    };
  }
})();
